export enum DragEvents {
    Enter = "ENTER",
    Hover = "HOVER",
    ExitDocument = "EXIT_DOCUMENT",
    ExitHover = "EXIT_HOVER",
    Drop = "DROP",
}